import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=1824c9f0&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports